export const base64ToArrayBuffer = (win: Window, data: string) => {
  const binaryString = win.atob(data);
  const binaryLen    = binaryString.length;
  const bytes        = new Uint8Array(binaryLen);

  for (let i = 0; i < binaryLen; i++) {
    bytes[ i ] = binaryString.charCodeAt(i);
  }

  return bytes;
};


export const decodeBase64 = (win: Window, pdf: string): Blob => {
  const arrBuffer = base64ToArrayBuffer(win, pdf);
  return new Blob([ arrBuffer ], { type: 'application/pdf' });
};
